import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import { HeroHeader, AcmeWide, Header5, ProximaNova } from "../components/typography";
import { SecondaryButton } from "../components/Button";
import { Colors } from "../components/styles/Colors";
import richText from "../utils/richText";
import KaramoSignature from './../assets/images/karamo-signature.png'
import { gsap, ScrollToPlugin } from 'gsap/all'
import Breakpoints from "../components/styles/Breakpoints";

gsap.registerPlugin(ScrollToPlugin)

const Wrapper = styled.div`
  position: relative;

  .headline {
    background-color: ${Colors.hunter};
    padding: 50px 30px 40px 30px;

    @media ${Breakpoints.desktop} {
      padding: 100px 130px 80px 130px;
    }

    ${HeroHeader} {
      color: ${Colors.lightBlue};
      opacity: .8;

      width: 100%;

      text-align: center;
      font-size: 64px;

      @media ${Breakpoints.desktop} {
        font-size: 200px;
        text-align: left;
      }
    }
  }

  .image-section {
    position: relative;

    .intro {
      display: flex;
      justify-content: flex-end;
      background-color: ${Colors.hunter};
      flex-direction: row;

      @media ${Breakpoints.desktop} {
        padding-bottom: 80px;
      }

      .inner {
        width: 100%;
        padding: 0px 30px;
        text-align: center;

        @media ${Breakpoints.desktop} {
          width: 50%;
          padding: 0px 140px;
          text-align: left;
        }

        & > div:first-child {
          position: relative;

          &:before {
            content: none;
            color: ${Colors.sage};
            font-size: 80px;
            position: absolute;
            top: 0px;
            left: 0px;
            font-family: ${AcmeWide};
            font-weight: 300;
            line-height: 1;
            transform: translate(-110%, -20%);

            @media ${Breakpoints.desktop} {
              content: '“';
            }
          }

          p {
            font-family: ${AcmeWide};
            font-weight: 300;

            font-size: 22px;
            line-height: 1.4;

            color: ${Colors.white};

            display: inline;

            @media ${Breakpoints.desktop} {
              font-size: 32px;
            }
          }

          span {
            color: ${Colors.white};
            font-family: ${AcmeWide};
            font-size: 22px;
            line-height: 1.4;
            font-weight: 300;

            @media ${Breakpoints.desktop} {
              color: ${Colors.sage};
              font-size: 32px;
            }

            &:first-child {
              @media ${Breakpoints.desktop} {
                display: none;
              }
            }
          }
        }

        img {
          width: 150px;
          margin-bottom: 20px;
          margin-top: 30px;
        }

        ${Header5} {
          color: white;
          margin-bottom: 55px;
        }

        ${SecondaryButton} {
          opacity: .8;
          width: 100%;

          @media ${Breakpoints.desktop} {
            width: auto;
          }
        }

        .gatsby-image-wrapper {
          width: 100%;
          transform: translateY(40px);

          @media ${Breakpoints.desktop} {
            display: none;
          }
        }
      }
    }

    .text {
      display: flex;
      justify-content: flex-end;
      background-color: ${Colors.cream3};
      padding: 80px 0px;

      .inner {
        width: 100%;
        padding: 0px 30px;

        @media ${Breakpoints.desktop} {
          width: 50%;
          padding: 0px 140px;
        }

        & > div:first-child {
          position: relative;

          p {
            font-family: ${ProximaNova};
            font-weight: 300;

            font-size: 22px;
            line-height: 1.4;

            color: ${Colors.darkGrey};
            margin-bottom: 22px;
          }
        }
      }
    }

    .image {
      width: 50%;
      position: absolute;
      top: 0px;
      left: 0px;
      height: 100%;
      padding: 0px 0px 80px 130px;
      display: none;

      @media ${Breakpoints.desktop} {
        display: block;
      }

      & > div:first-child {
        position: relative;
        width: 100%;
        height: 100%;

        .gatsby-image-wrapper {
          width: 100%;
          height: 100%;
          top: 0px;
          left: 0px;
        }
      }
    }
  }
`;

export default function KaramoHero({ headline, image, intro, text }) {
  function scroll () {
    gsap.to(window, { duration: 1, scrollTo: { y: `#favorites`, offsetY: 150 } })
  }
  
  return (
    <Wrapper>
      <div className="headline">
        <HeroHeader>{ headline }</HeroHeader>
      </div>

      <div className="image-section">
        <div className="image">
          <div>
            <Image style={{ position: 'absolute' }} fluid={image.fluid} />
          </div>
        </div>

        <div className="intro">
          <div className="inner">
            <div><span>“</span>{ richText(intro.raw) }<span>”</span></div>
            <img src={KaramoSignature}/>
            <Header5>Karamo Brown</Header5>
            <SecondaryButton onClick={scroll}>
              Shop Karamo's Favorites
            </SecondaryButton>

            <Image fluid={image.fluid} />
          </div>
        </div>

        <div className="text">
          <div className="inner">
            <div>{ richText(text.raw) }</div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
